import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client/react';
import GetVerificationCode from 'graphqlDocuments/queries/GetVerificationCode.graphql';
import { LoadingOverlay } from '@airtm/airtm-ui';
import { accountStatus as ACCOUNT_STATUS } from '@airtm/utils/dist/constants';

import SignupImage from 'assets/images/signup.jpg';
import PublicHeader from 'routes/PublicHeader';
import VerifyEmail from 'screens/Login/VerifyEmail';
import ServerError from 'screens/ServerError/ServerError';
import CompleteProfile from 'components/CompleteProfile/CompleteProfile';
import useMe from 'utils/hooks/useMe/useMe';

export default function withPartialStatus(Component) {
  const WithPartialStatusWrapper = function (props) {
    const { me, loading: loadingMe } = useMe();
    const { data, loading, error } = useQuery(GetVerificationCode, {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      skip: loadingMe || me?.status !== ACCOUNT_STATUS.PARTIAL,
    });

    if (loadingMe) return <LoadingOverlay />;

    if (me?.status !== ACCOUNT_STATUS.PARTIAL) {
      return <Component {...props} />;
    }

    if (loading) {
      return <LoadingOverlay />;
    }

    if (!data || error) {
      return <ServerError />;
    }

    const { getVerificationCode } = data;

    return (
      <>
        <PublicHeader />
        {getVerificationCode?.verified ? (
          <div className="content content--no-navigation">
            <div className="u-ovh">
              <div className="row justify-content-center">
                <div className="row col-12">
                  <div className="col-lg-6">
                    <img className="img-login-signup" src={SignupImage} alt="signup" />
                  </div>

                  <div className="col-12 col-sm-10 col-md-8 col-lg-4 offset-sm-1 offset-md-2 offset-lg-1">
                    <CompleteProfile {...props} user={me} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <VerifyEmail />
        )}
      </>
    );
  };

  WithPartialStatusWrapper.propTypes = {
    user: PropTypes.shape({
      status: PropTypes.string,
      email: PropTypes.string,
    }),
  };

  return WithPartialStatusWrapper;
}
